import React, { FC, ReactNode } from 'react';
import { CoreTooltipPlacement } from './types';
import { Tooltip as ChakraUITooltip } from '@chakra-ui/react';

export interface TooltipProps {
  label: string; // Todo: allow label to accept children or Reactnode?
  placement?: CoreTooltipPlacement | undefined;
  isOpen?: boolean;
  hasArrow?: true;
  children: ReactNode;
}

export const CoreTooltip: FC<TooltipProps> = ({ label, placement, hasArrow, isOpen, children }) => {
  /**
   * DOM
   */
  return (
    <ChakraUITooltip
      isOpen={isOpen}
      hasArrow={hasArrow}
      label={label}
      placement={placement}
      arrowPadding={4}
      arrowSize={8}
    >
      {children}
    </ChakraUITooltip>
  );
};
